import React from 'react';

export default function PublicProfile({ user, profileBelow }) {
	return (
		<div key={user.displayName} className={`not-prose flex flex-col gap-6 pt-12${profileBelow ? '' : ' @sm:flex-row @sm:gap-10'}`}>
			{user.picture !== null && (<img alt={user.displayName} src={user.picture} className="aspect-[4/5] w-52 flex-none rounded-2xl object-cover" />)}
			<div className="max-w-xl flex flex-col gap-2">
				{user.displayName && <h3 className="text-lg font-semibold leading-8 tracking-tight">{user.displayName}</h3>}
				{user.position && <p className="text-base leading-7">{user.position}</p>}
				{user.email ? (
					<a href={`mailto:${user.email}`}>
						{user.email}
					</a>
				) : null}
				{user.phone ? (
					<a href={`tel:${user.phone}`}>
						{user.phone}
					</a>
				) : null}
			</div>
		</div>
	);
}
